module.exports = __webpack_public_path__ + "img/card1.e6390f32.png";